import React, { useState, useEffect } from "react";
import ViewReceipts from "./ViewReceipts";
import TrackInventory from "./TrackInventory";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useNavigate, useSearchParams } from "react-router-dom";

const InventoryDashboard = ({ pharmacy }) => {
  const [activeTab, setActiveTab] = useState("track");
  const [racks, setRacks] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  // Get tab from URL or default to "track"
  useEffect(() => {
    const sectionParam = searchParams.get("t") || "track";
    setActiveTab(sectionParam);
  }, [searchParams]);

  const { data, isFetched, isLoading } = useItemsFilter(
    ApiEndPoint.PHARMACY,
    `?action=getRacks&pharmacy_id=${pharmacy}&all_rack_pharmacy=True`
  );

  useEffect(() => {
    if (isFetched) {
      setRacks(data);
    }
  }, [isFetched, pharmacy]);

  const tabs = [
    {
      key: "track",
      label: "Track Inventory",
      component: <TrackInventory racks={racks} />,
    },
    {
      key: "view",
      label: "View Receipts",
      component: <ViewReceipts pharmacy_id={pharmacy} />,
    },
  ];

  // Function to update URL without disturbing other parameters
  const handleTabChange = (tabKey) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("t", tabKey); // Update only "t" parameter
    setSearchParams(newSearchParams);
    setActiveTab(tabKey);
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Inventory Management
      </h1>

      {/* Navigation Tabs */}
      <div className="flex overflow-x-auto space-x-4 border-b mb-6 scrollbar-hide">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-4 py-2 text-sm font-medium transition-all duration-200 ${
              activeTab === tab.key
                ? "border-b-4 border-blue-500 text-blue-500"
                : "text-gray-600 hover:text-blue-500"
            }`}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Render Tab Content */}
      <div>{tabs.find((tab) => tab.key === activeTab)?.component}</div>

      {/* Loading Indicator */}
      {isLoading && (
        <div className="text-center mt-4">
          <p className="text-sm text-gray-500">Loading more data...</p>
        </div>
      )}
    </div>
  );
};

export default InventoryDashboard;
